import { z } from 'zod';
import { ErrorCode } from '../../shared/error-codes';
/**
 * Switch Tenant Request Schema
 * POST /api/v2/auth/switch-tenant
 * The response is the plain SignInResponse shape (signed-in-session.schema.ts):
 * a fresh token for the target tenant, no IdP round-trip.
 */ export const SwitchTenantRequestSchema = z.object({
    tenantId: z.string().min(1, ErrorCode.FIELD_REQUIRED)
});

//# sourceMappingURL=switch-tenant.schema.js.map